<template>
  <div>
    <!-- TOPBAR -->
    <v-app-bar color="secondary" light app>
      <v-app-bar-nav-icon
        @click="drawer = !drawer"
        class="white--text"
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="text-uppercase white--text pl-0">
        <span class="font-weight-light text-none">{{
          $t("mainMenu.toolbarTitlePortal")
        }}</span>
        <span class="font-weight-light">
          {{ $t("mainMenu.toolbarTitleFirst") }}</span
        >
        <span>{{ $t("mainMenu.toolbarTitleSecond") }}</span>
        <span
          no-gutters
          justify="end"
          class="caption font-weight-bold font-italic white--text text-none"
        >
          {{ $t("version") }}&#58;&nbsp;{{ version }}</span
        >
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title>
        <router-link :to="{ name: 'hfSelection' }" class="unstyled-anchor">
          <v-tooltip right content-class="portal-tooltip-inverted">
            <template v-slot:activator="{ on }">
              <span v-on="on" class="font-weight-light text-none white--text">{{
                $t("mainMenu.office")
              }}</span>
              <span v-on="on" class="font-weight-bold white--text">{{
                officeName
              }}</span>
            </template>
            <span>{{ changeOfficeTitle }}</span>
          </v-tooltip>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-badge
        top
        right
        color="red"
        overlap
        :value="existsUnreadNotifications"
        class="mx-5"
      >
        <div slot="badge" class="font-weight-bold">
          {{ numberOfUnreadNotifications }}
        </div>
        <v-tooltip bottom content-class="portal-tooltip-inverted">
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              icon
              text
              color="white"
              @click="openUnreadNotificationsPanel"
            >
              <v-icon dark>fas fa-bell</v-icon>
            </v-btn>
          </template>
          <span>{{ notificationTitle }}</span>
        </v-tooltip>
      </v-badge>
      <v-tooltip bottom content-class="portal-tooltip-inverted">
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            rounded
            small
            @click="logout"
            text
            color="white"
            class="body-2 font-weight-bold px-3"
          >
            <span>{{ $t("sign-out") }}</span>
            <v-icon class="ml-4">exit_to_app</v-icon>
          </v-btn>
        </template>
        <span>{{ logoutTitle }}</span>
      </v-tooltip>
    </v-app-bar>

    <!-- MENU' -->
    <v-navigation-drawer
      class="main-menu__nav-drawer pb-3"
      app
      light
      v-model="drawer"
      width="330"
    >
      <!-- LOGO -->
      <v-row no-gutters class="app-logo-container">
        <v-col class="ma-4">
          <div>
            <img
              class="official-logo text-center"
              alt="Fondo EST"
              src="./../../assets/images/official-logo.png"
            />
          </div>
        </v-col>
      </v-row>
      <!-- LOGGED IN USER DETAILS -->
      <v-card
        class="transparent mb-2 py-2"
        color="primary"
        text
        flat
        active-class="menu-voice-highlighted"
      >
        <v-row no-gutters justify-space-between>
          <v-col>
            <v-card-text class="py-0">
              <v-row no-gutters justify-center>
                <v-col sm="12" class="mb-2">
                  <span class="white--text title font-weight-bold">
                    {{ userFullName }}
                  </span>
                </v-col>
                <v-col sm="12">
                  <span
                    class="body-2 font-weight-bold white--text"
                    v-html="getUserRolesString"
                  ></span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-col>
          <v-col sm="auto" class="py-2 pr-3">
            <v-row no-gutters>
              <v-col class="pa-0">
                <v-tooltip top content-class="portal-tooltip-inverted">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      icon
                      text
                      color="white"
                      @click="goToProfile"
                    >
                      <v-icon dark>fas fa-user-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ profileTitle }}</span>
                </v-tooltip>
              </v-col>
              <v-col class="py-0 pl-2 pr-0">
                <v-tooltip top content-class="portal-tooltip-inverted">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      icon
                      text
                      color="white"
                      @click="logout"
                    >
                      <v-icon>exit_to_app</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ logoutTitle }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <v-row no-gutters="">
        <v-col
          cols="12"
          class="px-4 py-3 white--text mb-3"
          :class="
            isActiveRoute({ routeName: 'home' }) ? 'menu-voice-highlighted' : ''
          "
        >
          <router-link :to="{ name: 'home' }" class="unstyled-anchor">
            <h2 class="title white--text">
              {{ $t(`mainMenu.groupItems.none.home`) }}
            </h2>
          </router-link>
        </v-col>
      </v-row>
      <v-expansion-panels
        v-model="menuExpansionpanels"
        multiple
        accordion
        tile
        flat
        class="main-menu px-0"
      >
        <v-expansion-panel
          v-for="(menuGroupItem, i) in getFilteredMenuCategories"
          :key="i"
          class="my-0 pa-0 menu-list white--text"
        >
          <v-expansion-panel-header
            class="px-4 py-3"
            :class="{ 'has-divider': !menuGroupItem.subheader.match('none') }"
          >
            <span
              style="line-height: 22px"
              class="white--text menu-category-title font-weight-bold"
            >
              {{
                $t(`mainMenu.groupItems.${menuGroupItem.subheader}.subheader`)
              }}
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="px-0">
            <v-list
              v-for="menuItem in menuGroupItem.items"
              :key="menuItem.name"
              class="py-0"
            >
              <v-list-item
                @click="menuItem.action(isActiveRoute(menuItem))"
                active-class="menu-voice-highlighted"
                :class="isActiveRoute(menuItem) ? 'menu-voice-highlighted' : ''"
                class="menu-item"
              >
                <v-list-item-action class="mr-4" style="width: 10%">
                  <img
                    v-if="isAnInternalIcon(menuItem.iconType)"
                    :src="require('@/assets/icons/'.concat(menuItem.icon))"
                    width="100%"
                    alt
                  />
                  <v-icon v-else dark>{{ menuItem.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title
                  class="white--text"
                  :title="
                    $t(
                      `mainMenu.groupItems.${menuGroupItem.subheader}.${menuItem.name}`
                    )
                  "
                >
                  {{
                    $t(
                      `mainMenu.groupItems.${menuGroupItem.subheader}.${menuItem.name}`
                    )
                  }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-navigation-drawer>
  </div>
</template>

<script>
import menuConf from "./menuConf";

export default {
  data() {
    return {
      menuExpansionpanels: [0, 1, 2, 3],
      drawer: true,
      menuConf: menuConf,
      profileTitle: this.$t("mainMenu.profileButtonTitle"),
      logoutTitle: this.$t("mainMenu.logoutButtonTitle"),
      notificationTitle: this.$t("mainMenu.notificationButtonTitle"),
      changeOfficeTitle: this.$t("mainMenu.changeOfficeButtonTitle"),
      version: process.env.VUE_APP_VERSION
    };
  },
  computed: {
    getFilteredMenuCategories() {
      return this.menuConf.groupItems.filter(
        item => !item.subheader.match("none")
      );
    },
    hfUserRoles() {
      return this.$store.getters["hfManagement/getHfUserRoles"];
    },
    getUserRolesString() {
      return this.hfUserRoles.join("<br>");
    },
    officeName() {
      let office = this.$store.getters["hfManagement/selectedHfOffice"];
      return office?.legalName;
    },
    loading() {
      return this.$store.getters["loading/loadingDialog"];
    },
    userFullName() {
      return this.$store.getters["auth/userFullName"];
    },
    checkProfileSelected() {
      return "profile" === this.$route.name;
    },
    numberOfUnreadNotifications() {
      return this.$store.getters[
        "notifications/getNumberOfUnreadNotifications"
      ];
    },
    existsUnreadNotifications() {
      return (
        this.numberOfUnreadNotifications && this.numberOfUnreadNotifications > 0
      );
    }
  },
  methods: {
    goToProfile() {
      this.$router.push({ name: "profile" });
    },
    isActiveRoute(menuItem) {
      return menuItem.routeName == this.$route.name;
    },
    isAMaterialDesignIcon(iconType) {
      return iconType && iconType === "md";
    },
    isAnInternalIcon(iconType) {
      return iconType && iconType === "internal";
    },
    logout() {
      this.$store.dispatch("logout", null, {
        root: true
      });
    },
    async openUnreadNotificationsPanel() {
      await this.$store.dispatch("notifications/getUnreadNotifications");
      if (this.existsUnreadNotifications) {
        this.$store.commit("notifications/setShowNotificationPanel", true);
      } else {
        this.$router.push({ name: "notificationsCenter" });
      }
    }
  },
  created() {
    this.drawer =
      this.$vuetify.breakpoint.xs ||
      this.$vuetify.breakpoint.sm ||
      this.$vuetify.breakpoint.md
        ? false
        : true;
  }
};
</script>

<style scoped>
.home-menu-item a {
  text-decoration: none !important;
}
.main-menu >>> .v-expansion-panel-content__wrap {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.main-menu >>> .v-expansion-panel-header__icon i {
  color: white !important;
}
.main-menu >>> .v-expansion-panel {
  background-color: transparent !important;
}
.has-divider {
  border-top: 2px solid lightgrey;
}
.app-logo-container {
  background-color: var(--secondary);
}

.unstyled-anchor {
  text-decoration: none !important;
}
.toolbar {
  z-index: 9;
}
.main-menu__nav-drawer {
  overflow-y: hidden;
}
.v-navigation-drawer {
  background: linear-gradient(
      rgba(36, 120, 181, 1) 20%,
      rgba(36, 120, 181, 0.3) 70%
    ),
    url("../../assets/images/bg-main.jpg") !important;
}

.v-navigation-drawer .v-list {
  background: transparent !important;
}
.theme--light.v-toolbar {
  background-color: var(--secondary);
  color: #ffffff;
}

.menu-category-title {
  font-size: 18px;
}

.menu-list >>> .v-list__group::before,
.menu-list >>> .v-list__group::after {
  background: unset;
}

.menu-list >>> .v-list__tile {
  height: 50px;
}

.menu-item >>> .v-list__tile {
  height: 36px;
}

.menu-item >>> .v-list__tile__action {
  min-width: 30px;
}

.menu-group >>> .v-list__group__header__append-icon {
  padding-left: 0;
  padding-right: 30px;
}

.menu-group >>> .v-icon {
  color: white;
}

.menu-voice-highlighted {
  background-color: var(--primary) !important;
}
</style>
